import React, { useContext } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { t } from 'i18next';
import { MarsinetContext } from '../../context/marsinetProvider';

const ErrorModal = () => {
  const { error, setError } = useContext(MarsinetContext);

  return (
    <div>
      <Dialog
        visible={error}
        modal
        onHide={() => setError(false)}
        className="error-modal-dialog"
        style={{
          borderRadius: '12px',
          backgroundImage:
            'radial-gradient(circle at left top, var(--primary-400), var(--primary-700))',
        }}
      >
        <div
          className="flex flex-column px-8 py-5 gap-4"
          style={{
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            className="flex justify-content-center align-items-center"
            style={{
              width: '100px', // Ancho del círculo
              height: '100px', // Alto del círculo
              borderRadius: '50%',
              textAlign: 'center',
              backgroundColor: 'rgba(255, 0, 0, 0.1)', // Fondo rojo semitransparente
            }}
          >
            <i className="pi pi-times-circle text-6xl text-red-500" />
          </div>
          <div className="text-red-500 font-bold text-3xl">
            {t('messages.error_message')}
          </div>
          <div className="text-xl">
            {t('messages.contact')}
            <a
              href="mailto:soporte.marsinet@marsibionics.com"
              className="font-bold text-gray-800"
            >
              soporte.marsinet@marsibionics.com
            </a>
            .
          </div>
          <Button
            label={t('close')}
            icon="pi pi-check"
            onClick={() => setError(false)}
            severity="danger"
          />
        </div>
      </Dialog>
    </div>
  );
};

export default ErrorModal;
